module.exports = __webpack_public_path__ + "static/media/liveDrawBg.b599f22a.png";